import React, {useEffect} from 'react';

import BackButton from '@/components/BackButton/BackButton';
import {ButtonRaw} from '@/components/Button';
import {BinIcon} from '@/components/Icons';
import AppLoaderContent from '@/components/Loader/AppLoader/AppLoaderContent';
import {PopoverStickyTitle} from '@/components/Popover/Popover';
import {ScrollArea} from '@/components/ScrollArea/ScrollArea';
import {INBOX_DELETE_MESSAGE_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import * as sourceTypes from '@/consts/sourceTypes';
import {NotificationDetailsMessage} from '@/containers/Inbox/NotificationDetails/components/NotificationDetailsMessage';
import useMessageDeletionWithUndo from '@/hooks/inbox/useMessageDeletionWithUndo';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeInboxTracking from '@/services/analytics/amplitude/amplitudeInboxTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';

const InboxPopoverNotificationDetails = ({
    message,
    isLoaderActive,
    closeNotificationDetails,
    containerRef,
    className,
    backButtonRef,
    isDark,
}) => {
    useEffect(() => {
        if (message) {
            amplitudeInboxTracking.trackNotificationDetailedScreen(sourceTypes.INBOX, message.campaignName);
            googleAnalyticsService.trackInboxDetailsScreenView(sourceTypes.INBOX, message.campaignName);
        }
    }, [message]);

    const handleMessageDeleteClick = useMessageDeletionWithUndo({messageId: message?.messageId});
    const onDeleteClick = () => {
        handleMessageDeleteClick();
        closeNotificationDetails();
    };

    return (
        <>
            <ScrollArea className='flex-1 py-0'>
                <PopoverStickyTitle
                    contentElement={containerRef.current}
                    className='sticky left-0 right-0 flex items-center justify-between'
                    isDark={isDark}
                >
                    <BackButton onClick={closeNotificationDetails} ref={backButtonRef} />
                    <ButtonRaw
                        onClick={onDeleteClick}
                        aria-label={getAriaLabel(INBOX_DELETE_MESSAGE_BUTTON_ARIA_LABEL)}
                    >
                        <BinIcon />
                    </ButtonRaw>
                </PopoverStickyTitle>
                <div className='px-6'>
                    {isLoaderActive ? (
                        <div className='flex h-full items-center justify-center'>
                            <AppLoaderContent />
                        </div>
                    ) : (
                        <div className='flex flex-col pt-2 text-start'>
                            <NotificationDetailsMessage isDark={isDark} onDeleteClick={onDeleteClick} {...message} />
                        </div>
                    )}
                </div>
            </ScrollArea>
        </>
    );
};

export default InboxPopoverNotificationDetails;
